import React from "react";
import { Footer as UIFooter } from "toddlar-ui";

const Footer: React.FC = () => {
  return (
    <UIFooter
      links={[
        { label: "Privacy", href: "#" },
        { label: "Terms", href: "#" },
        { label: "Contact", href: "#" },
      ]}
    />
  );
};

export default Footer;
